import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=6405bba9&lang=scss&scoped=true"

import exportComponent from "/Users/tyk/Desktop/work/kangleiot/biz-sharingspace/sharing-space-admin-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6405bba9"]])

export default __exports__